import React from 'react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-scroll';

import { navConfig, feedConfig } from '../config/navConfig';
import MenuItem from './MenuItem';

const ClassicHeader = ({ handleNavClick, lang, setLang }) => {
  const [stickyHeader, setStickyHeader] = useState(false);
  const [isNavModalClose, setIsNavModalClose] = useState(true);

  const checkScrollTop = () => {
    let header = document.getElementsByClassName('primary-menu');

    if (header) {
      if (
        document.body.scrollTop > 180 ||
        document.documentElement.scrollTop > 180
      ) {
        setStickyHeader(true);
      } else {
        setStickyHeader(false);
      }
    }
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', checkScrollTop);
  }

  return (
    <header id="header" className="sticky-top-slide">
      {/* Navbar */}
      <nav
        className={
          'primary-menu navbar navbar-expand-lg navbar-dark bg-transparent border-bottom-0 sticky-top ' +
          (stickyHeader ? 'sticky-on' : '')
        }>
        <div className="container-fluid main-padding position-relative g-lg-4">
          <div className="col-auto col-lg-2">
            {/* Logo */}
            <Link
              smooth
              duration={500}
              style={{ cursor: 'pointer' }}
              className="logo"
              to="home"
              title="gonumerik"
              onClick={(e) => {
                e.preventDefault();
                setIsNavModalClose(true);
              }}>
              <img
                style={{ width: '60px', background: 'transparent' }}
                src="images/gon-logo-trans.png"
                alt="Go-Numerik"
              />
              <span className="px-2 fs-4 fst-italic">GO-NUMERIK</span>
              <span className="fst-italic logo-bit">
                <FormattedMessage
                  id="logo-bit"
                  defaultMessage="crafting technology"
                />
              </span>
            </Link>
            {/* Logo End */}
          </div>
          <div className="col col-lg-8 navbar-accordion">
            <button
              onClick={(e) => {
                setIsNavModalClose(!isNavModalClose);
              }}
              className={
                isNavModalClose
                  ? 'navbar-toggler ms-auto'
                  : 'navbar-toggler ms-auto show'
              }
              id="navbar-toggler"
              type="button">
              <span />
              <span />
              <span />
            </button>
            <div
              id="header-nav"
              className={
                isNavModalClose
                  ? 'collapse navbar-collapse justify-content-end '
                  : 'show navbar-collapse justify-content-center'
              }>
              <ul className="navbar-nav">
                {navConfig.map((config) => (
                  <MenuItem
                    key={config.titleKey}
                    titleKey={config.titleKey}
                    linkTo={config.linkTo}
                    title={config.defaultTitle}
                    defaultTitle={config.defaultTitle}
                    onClick={(e) => {
                      e.preventDefault();
                      setIsNavModalClose(true);
                    }}
                    source="classic-header"
                  />
                ))}
                {!isNavModalClose && (
                  <div className="lang-collapse">
                    <span
                      onClick={() => setLang('fr')}
                      style={{ color: lang === 'fr' ? '#9acd32' : '#ddd' }}>
                      FR
                    </span>{' '}
                    &nbsp; | &nbsp;
                    <span
                      onClick={() => setLang('en')}
                      style={{ color: lang === 'en' ? '#9acd32' : '#ddd' }}>
                      EN
                    </span>
                  </div>
                )}
              </ul>
            </div>
          </div>
          <div className="col-auto col-lg-2 d-flex justify-content-end">
            <div className="lang-open">
              <span
                onClick={() => setLang('fr')}
                style={{
                  color: lang === 'fr' ? '#9acd32' : '#ddd',
                  cursor: 'pointer',
                }}>
                fr
              </span>{' '}
              &nbsp;| &nbsp;
              <span
                onClick={() => setLang('en')}
                style={{
                  color: lang === 'en' ? '#9acd32' : '#ddd',
                  cursor: 'pointer',
                }}>
                en
              </span>
            </div>
            {/* <ul className="social-icons social-icons-light">
              {          
              feedConfig.map(config=>
                <li key={config.href} className="social-icons-facebook">
                  <Tooltip text={config.text} placement="top">
                    <a
                      href={config.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className={config.className} />
                    </a>
                  </Tooltip>
                </li>)
              }
            </ul> */}
          </div>
        </div>
      </nav>
      {/* Navbar End */}
    </header>
  );
};

export default ClassicHeader;
